import script from "./ofinaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ofinaForm.vue?vue&type=script&setup=true&lang=js"

import "./ofinaForm.vue?vue&type=style&index=0&id=772758b0&scoped=true&lang=css"
import "./ofinaForm.vue?vue&type=style&index=1&id=772758b0&lang=css"
import "./ofinaForm.vue?vue&type=style&index=2&id=772758b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772758b0"]])

export default __exports__